{
  "name": "nvcockpit-rockt",
  "version": "2026.3.0",
  "author": "NV",
  "private": true,
  "registry": "https://repo.nv.at/repository/registry.npm.nv",
  "engines": {
    "node": ">=18",
    "npm": ">=8"
  },
  "scripts": {
    "ng": "ng",
    "build": "npm run env -s && ng build",
    "build:dev": "npm run env -s && ng build --configuration=development",
    "build:prod": "npm run env -s && ng build --configuration=production",
    "start": "npm run env -s && ng serve",
    "start:local": "npm run env -s && ng serve --configuration=local",
    "serve:sw": "npm run env -s && ng build --configuration=local && npx http-server ./dist -p 4200",
    "lint": "ng lint && stylelint \"src/**/*.scss\" --syntax scss && htmlhint \"src\" --config .htmlhintrc",
    "test": "npm run env -s && ng test",
    "test:ci": "npm run env -s && npm run lint -s && ng test --configuration=ci",
    "env": "ngx-scripts env npm_package_version",
    "generate": "ng generate",
    "docker:build:development": "bash -c \"docker build --no-cache --build-arg node_env=dev -t repo.nv.at/pezi/pezi-client/dev:$npm_package_version .\"",
    "docker:build:production": "bash -c \"docker build --no-cache --build-arg node_env=prod -t repo.nv.at/pezi/pezi-client/prod:$npm_package_version .\"",
    "docker:release:development": "npm run docker:build:development && bash -c \"docker push repo.nv.at/pezi/pezi-client/dev:$npm_package_version\"",
    "docker:release:production": "npm run docker:build:production && bash -c \"docker push repo.nv.at/pezi/pezi-client/prod:$npm_package_version\""
  },
  "dependencies": {
    "@angular/animations": "19.2.20",
    "@angular/cdk": "19.2.19",
    "@angular/common": "19.2.20",
    "@angular/compiler": "19.2.20",
    "@angular/core": "19.2.20",
    "@angular/forms": "19.2.20",
    "@angular/google-maps": "19.2.19",
    "@angular/material": "19.2.19",
    "@angular/platform-browser": "19.2.20",
    "@angular/platform-browser-dynamic": "19.2.20",
    "@angular/router": "19.2.20",
    "@angular/service-worker": "19.2.20",
    "@googlemaps/js-api-loader": "1.16.8",
    "@googlemaps/markerclusterer": "2.5.3",
    "@karl/theme": "0.3.12",
    "@material/layout-grid": "14.0.0",
    "@ngneat/elf": "2.5.1",
    "@ngneat/elf-entities": "5.0.2",
    "@ngneat/elf-persist-state": "1.2.1",
    "@ngneat/until-destroy": "10.0.0",
    "chart.js": "4.4.5",
    "file-saver": "2.0.5",
    "hammerjs": "2.0.8",
    "material-design-icons-iconfont": "6.7.0",
    "moment": "2.30.1",
    "ng2-charts": "5.0.4",
    "ngx-device-detector": "9.0.0",
    "rxjs": "7.8.1",
    "zone.js": "0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "19.2.23",
    "@angular-eslint/builder": "19.2.1",
    "@angular-eslint/eslint-plugin": "19.2.1",
    "@angular-eslint/eslint-plugin-template": "19.2.1",
    "@angular-eslint/schematics": "19.2.1",
    "@angular-eslint/template-parser": "19.2.1",
    "@angular/cli": "19.2.23",
    "@angular/compiler-cli": "19.2.20",
    "@angular/language-service": "19.2.20",
    "@angularclass/hmr": "3.0.0",
    "@ngx-rocket/scripts": "5.2.3",
    "@pezi/entities": "0.0.693",
    "@types/file-saver": "2.0.7",
    "@types/google.maps": "3.58.1",
    "@types/node": "20.16.11",
    "@types/quill": "1.3.10",
    "@types/supercluster": "7.1.3",
    "@typescript-eslint/eslint-plugin": "8.9.0",
    "@typescript-eslint/parser": "8.9.0",
    "eslint": "9.12.0",
    "eslint-plugin-jsdoc": "50.4.1",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "eslint-plugin-react": "7.37.1",
    "prettier": "3.3.3",
    "pretty-quick": "4.0.0",
    "stylelint": "16.10.0",
    "stylelint-config-recommended-scss": "14.1.0",
    "stylelint-config-standard": "36.0.1",
    "stylelint-scss": "6.7.0",
    "ts-node": "10.9.2",
    "typescript": "5.5.4"
  }
}
